<template>
  <div
    class="sidebar-title"
    :class="[
      `sidebar-title--${size}`,
      { 'sidebar-title--no-border': noBorder },
    ]"
  >
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "SidebarTitle",
  props: {
    title: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.sidebar-title {
  font-size: 1.6rem;
  font-weight: 700;
  border-bottom: 1px solid $border;
  color: $text;
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.6rem;
  &--small {
    font-size: 1.4rem;
  }
  &--no-border {
    border-bottom: none;
    margin-bottom: 0;
  }
}
</style>
